// import React, { useState, useMemo } from 'react';
// import { 
//   Search, 
//   Calendar, 
//   BookOpen, 
//   Filter, 
//   X, 
//   ChevronLeft, 
//   ChevronRight, 
//   Lock, 
//   Globe, 
//   SlidersHorizontal,
//   Mail,
//   ArrowUpRight
// } from 'lucide-react';

// // Mock Data structure based on your database 'knowledgepublications'
// const MOCK_REPORTS = [
//   {
//     id: 1,
//     slug: "el-salvador-validated-who-trachoma",
//     title: "El Salvador validated by WHO as having eliminated trachoma as a public health problem",
//     image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=600",
//     publish_date: "2026-07-13",
//     paid_access: 0,
//     topic: "Healthcare & Life Sciences",
//     type: "News Release"
//   },
//   {
//     id: 2,
//     slug: "who-civil-society-commission-priorities",
//     title: "The WHO Civil Society Commission reshapes priorities at the World Health Assembly",
//     image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&q=80&w=600",
//     publish_date: "2026-07-10",
//     paid_access: 1,
//     topic: "Policy & Governance",
//     type: "Departmental Update"
//   },
//   {
//     id: 3,
//     slug: "who-global-regulators-greener-pharmaceuticals",
//     title: "WHO and global regulators advance shared roadmap for greener pharmaceuticals and environmentally friendly chemicals",
//     image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=600",
//     publish_date: "2026-07-10",
//     paid_access: 1,
//     topic: "Environment & Sustainability",
//     type: "Departmental Update"
//   },
//   {
//     id: 4,
//     slug: "india-renewable-energy-milestones-2026",
//     title: "India's Renewable Energy Path: Milestones, Opportunities, and Policy Roadmap for Green Hydrogen Integration",
//     image: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&q=80&w=600",
//     publish_date: "2026-06-28",
//     paid_access: 0,
//     topic: "Energy & Power",
//     type: "Annual Report"
//   },
//   {
//     id: 5,
//     slug: "fintech-disruption-banking-reforms",
//     title: "Fintech Disruption and Next-Gen Banking: Navigating Digital Currencies and Financial Inclusivity in Rural Markets",
//     image: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&q=80&w=600",
//     publish_date: "2026-05-15",
//     paid_access: 0,
//     topic: "Banking & Finance",
//     type: "Whitepaper"
//   },
//   {
//     id: 6,
//     slug: "cybersecurity-framework-infrastructure-protection",
//     title: "Comprehensive Cybersecurity Framework for Critical National Infrastructure Protection against Global Ransomware Threats",
//     image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=600",
//     publish_date: "2026-04-02",
//     paid_access: 1,
//     topic: "Technology & IT",
//     type: "Survey Report"
//   },
//   {
//     id: 7,
//     slug: "electric-vehicles-infrastructure-expansion",
//     title: "Electric Vehicle Infrastructure Expansion: Charging Station Networks and Supply Chain Resiliency Analysis",
//     image: "https://images.unsplash.com/photo-1563720223185-11003d516935?auto=format&fit=crop&q=80&w=600",
//     publish_date: "2026-03-20",
//     paid_access: 0,
//     topic: "Automotive & Logistics",
//     type: "Survey Report"
//   },
//   {
//     id: 8,
//     slug: "agriculture-4-0-smart-farming",
//     title: "Agriculture 4.0: Smart Farming and IoT Technologies Redefining Crop Yields and Resource Optimization Strategies",
//     image: "https://images.unsplash.com/photo-1625246140024-b786f6f21d30?auto=format&fit=crop&q=80&w=600",
//     publish_date: "2026-02-14",
//     paid_access: 1,
//     topic: "Agriculture",
//     type: "Whitepaper"
//   }
// ];

// export default function ReportSection() {
//   // State variables matching requirements
//   const [keyword, setKeyword] = useState("");
//   const [selectedTopic, setSelectedTopic] = useState("All Topics");
//   const [selectedType, setSelectedType] = useState("All Types");
//   const [selectedYear, setSelectedYear] = useState("All Years");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [emailInput, setEmailInput] = useState("");
//   const [subscribed, setSubscribed] = useState(false);

//   const ITEMS_PER_PAGE = 6;

//   // Extract unique filtering values dynamically
//   const topicsList = useMemo(() => {
//     const list = new Set(MOCK_REPORTS.map(item => item.topic));
//     return ["All Topics", ...Array.from(list)];
//   }, []);

//   const typesList = useMemo(() => {
//     const list = new Set(MOCK_REPORTS.map(item => item.type));
//     return ["All Types", ...Array.from(list)];
//   }, []);

//   const yearsList = useMemo(() => {
//     const list = new Set(MOCK_REPORTS.map(item => {
//       const year = new Date(item.publish_date).getFullYear();
//       return year.toString();
//     }));
//     return ["All Years", ...Array.from(list).sort((a,b) => b - a)];
//   }, []);

//   // Filter Logic
//   const filteredReports = useMemo(() => {
//     return MOCK_REPORTS.filter((report) => {
//       const matchesKeyword = report.title.toLowerCase().includes(keyword.toLowerCase()) || 
//                              report.topic.toLowerCase().includes(keyword.toLowerCase());
//       const matchesTopic = selectedTopic === "All Topics" || report.topic === selectedTopic;
//       const matchesType = selectedType === "All Types" || report.type === selectedType;
//       const matchesYear = selectedYear === "All Years" || new Date(report.publish_date).getFullYear().toString() === selectedYear;

//       return matchesKeyword && matchesTopic && matchesType && matchesYear;
//     });
//   }, [keyword, selectedTopic, selectedType, selectedYear]);

//   // Pagination bounds calculation
//   const totalPages = Math.ceil(filteredReports.length / ITEMS_PER_PAGE);
//   const displayedReports = useMemo(() => {
//     const start = (currentPage - 1) * ITEMS_PER_PAGE;
//     return filteredReports.slice(start, start + ITEMS_PER_PAGE);
//   }, [filteredReports, currentPage]);

//   const handlePageChange = (pageNo) => {
//     if (pageNo >= 1 && pageNo <= totalPages) {
//       setCurrentPage(pageNo);
//       window.scrollTo({ top: 320, behavior: 'smooth' });
//     }
//   };

//   const handleResetFilters = () => {
//     setKeyword("");
//     setSelectedTopic("All Topics");
//     setSelectedType("All Types");
//     setSelectedYear("All Years");
//     setCurrentPage(1);
//   };

//   const handleSubscriptionSubmit = (e) => {
//     e.preventDefault();
//     if(emailInput.trim() !== "") {
//       setSubscribed(true);
//       setEmailInput("");
//       setTimeout(() => setSubscribed(false), 5000);
//     }
//   };

//   // Helper date formatter function
//   const formatDate = (dateStr) => {
//     const options = { day: 'numeric', month: 'long', year: 'numeric' };
//     return new Date(dateStr).toLocaleDateString('en-GB', options);
//   };

//   return (
//     <div className="min-h-screen font-sans bg-[#FAF3F0] text-gray-800 selection:bg-[#DA2128]/20 selection:text-[#DA2128]">
      
//       {/* 1. HERO BANNER DESIGN */}
//       <div className="relative overflow-hidden bg-gradient-to-r from-[#2a2a2a] via-[#1a1a1a] to-[#2a2a2a] py-20 text-white">
//         <div className="absolute inset-0 opacity-15 pointer-events-none">
//           <div className="absolute -top-1/2 -left-1/4 w-96 h-96 bg-[#DA2128] rounded-full filter blur-[120px]"></div>
//           <div className="absolute -bottom-1/2 -right-1/4 w-96 h-96 bg-[#F59C00] rounded-full filter blur-[120px]"></div>
//         </div>
        
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//           <div className="flex flex-col md:flex-row items-center justify-between gap-12">
//             <div className="flex-1 text-left space-y-6">
//               <span className="inline-flex items-center px-3.5 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider bg-[#DA2128] text-white animate-pulse">
//                 ASSOCHAM Knowledge Hub
//               </span>
//               <h1 className="text-4xl md:text-6xl font-black tracking-tight leading-tight">
//                 Insights <span className="text-[#DA2128]">&</span> Analysis
//               </h1>
//               <p className="text-lg md:text-xl text-gray-300 max-w-xl font-light">
//                 Empowering business communities with state-of-the-art reports, research publications, and forward-looking economic analysis.
//               </p>
//               <div className="h-1.5 w-24 bg-[#F59C00] rounded-full"></div>
//             </div>
            
//             <div className="flex-1 w-full max-w-md hidden md:block">
//               <div className="relative group overflow-hidden rounded-2xl border-4 border-white/10 shadow-2xl transition-transform duration-500 hover:scale-[1.02]">
//                 <img 
//                   src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=800" 
//                   alt="Tech Graphics" 
//                   className="object-cover w-full h-[280px]" 
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex items-end p-6">
//                   <p className="text-sm font-medium text-white/95">Trusted Knowledge Center with 10,000+ active publications.</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 -mt-10 relative z-20">
        
//         {/* 2. ADVANCED INTERACTIVE FILTER SECTION */}
//         <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 mb-10 transition-all duration-300 hover:shadow-2xl">
//           <div className="flex items-center justify-between border-b border-gray-100 pb-4 mb-6">
//             <div className="flex items-center gap-2">
//               <SlidersHorizontal className="text-[#DA2128] w-5 h-5" />
//               <h3 className="font-bold text-lg text-gray-900 tracking-tight">Refine Intelligence Database</h3>
//             </div>
//             {(keyword || selectedTopic !== "All Topics" || selectedType !== "All Types" || selectedYear !== "All Years") && (
//               <button 
//                 onClick={handleResetFilters}
//                 className="flex items-center gap-1.5 text-xs text-red-500 hover:text-red-700 font-medium transition-colors"
//               >
//                 <X className="w-4.5 h-4.5" /> Clear Filters
//               </button>
//             )}
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            
//             {/* Search Input Box */}
//             <div className="relative group">
//               <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Search Key</label>
//               <div className="relative">
//                 <input 
//                   type="text" 
//                   placeholder="Type titles or keywords..."
//                   value={keyword}
//                   onChange={(e) => { setKeyword(e.target.value); setCurrentPage(1); }}
//                   className="w-full pl-10 pr-4 py-3 bg-[#FAF7F2] border border-gray-200 rounded-xl text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128] focus:border-transparent transition-all duration-300"
//                 />
//                 <Search className="absolute left-3.5 top-3.5 text-gray-400 group-focus-within:text-[#DA2128] transition-colors w-4.5 h-4.5" />
//               </div>
//             </div>

//             {/* Topic Filter Select */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Topic Sector</label>
//               <div className="relative">
//                 <select 
//                   value={selectedTopic}
//                   onChange={(e) => { setSelectedTopic(e.target.value); setCurrentPage(1); }}
//                   className="w-full px-4 py-3 bg-[#FAF7F2] border border-gray-200 rounded-xl text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128] focus:border-transparent transition-all duration-300 appearance-none cursor-pointer"
//                 >
//                   {topicsList.map((topic, i) => (
//                     <option key={i} value={topic}>{topic}</option>
//                   ))}
//                 </select>
//                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
//                   <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
//                 </div>
//               </div>
//             </div>

//             {/* Report Type Select */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Report Category</label>
//               <div className="relative">
//                 <select 
//                   value={selectedType}
//                   onChange={(e) => { setSelectedType(e.target.value); setCurrentPage(1); }}
//                   className="w-full px-4 py-3 bg-[#FAF7F2] border border-gray-200 rounded-xl text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128] focus:border-transparent transition-all duration-300 appearance-none cursor-pointer"
//                 >
//                   {typesList.map((type, i) => (
//                     <option key={i} value={type}>{type}</option>
//                   ))}
//                 </select>
//                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
//                   <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
//                 </div>
//               </div>
//             </div>

//             {/* Date Range Selector */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Publishing Year</label>
//               <div className="relative">
//                 <select 
//                   value={selectedYear}
//                   onChange={(e) => { setSelectedYear(e.target.value); setCurrentPage(1); }}
//                   className="w-full px-4 py-3 bg-[#FAF7F2] border border-gray-200 rounded-xl text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128] focus:border-transparent transition-all duration-300 appearance-none cursor-pointer"
//                 >
//                   {yearsList.map((year, i) => (
//                     <option key={i} value={year}>{year}</option>
//                   ))}
//                 </select>
//                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
//                   <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>

//         {/* 3. REPORT LIST VIEWS (As reference image format) */}
//         <div className="space-y-6">
//           <div className="flex justify-between items-center px-2">
//             <p className="text-sm font-medium text-gray-500">
//               Showing <span className="font-bold text-gray-800">{filteredReports.length}</span> scientific reports
//             </p>
//           </div>

//           {displayedReports.length > 0 ? (
//             <div className="space-y-4">
//               {displayedReports.map((report, idx) => (
//                 <div 
//                   key={report.id} 
//                   className="group relative flex flex-col md:flex-row items-stretch bg-white border border-gray-100/80 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
//                   style={{ animationDelay: `${idx * 100}ms` }}
//                 >
//                   {/* Left Side: Thumbnail with dynamic badges */}
//                   <div className="relative w-full md:w-56 h-44 md:h-auto min-h-[170px] overflow-hidden flex-shrink-0 bg-gray-200">
//                     <img 
//                       src={report.image} 
//                       alt={report.title} 
//                       className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
//                     />
//                     <div className="absolute inset-0 bg-black/5 group-hover:bg-black/0 transition-colors"></div>
                    
//                     {/* Access Badges */}
//                     {report.paid_access === 1 ? (
//                       <div className="absolute top-3 left-3 flex items-center gap-1 bg-[#DA2128] text-white text-[10px] uppercase font-bold tracking-widest px-2.5 py-1 rounded shadow-lg backdrop-blur-md">
//                         <Lock className="w-3 h-3" /> Members Only
//                       </div>
//                     ) : (
//                       <div className="absolute top-3 left-3 flex items-center gap-1 bg-green-600 text-white text-[10px] uppercase font-bold tracking-widest px-2.5 py-1 rounded shadow-lg backdrop-blur-md">
//                         <Globe className="w-3 h-3" /> Free Access
//                       </div>
//                     )}
//                   </div>

//                   {/* Right Side: Content Area conforming to user screenshot */}
//                   <div className="flex-1 p-6 md:p-8 flex flex-col justify-between">
//                     <div>
//                       {/* Meta section matching: Date | Category */}
//                       <div className="flex flex-wrap items-center gap-2 text-xs font-semibold text-gray-500 mb-3 tracking-wider uppercase">
//                         <span className="flex items-center gap-1 text-gray-600 font-medium">
//                           <Calendar className="w-3.5 h-3.5 text-[#DA2128]" />
//                           {formatDate(report.publish_date)}
//                         </span>
//                         <span className="text-gray-300">|</span>
//                         <span className="text-[#DA2128] font-bold bg-[#DA2128]/5 px-2.5 py-0.5 rounded-full">{report.type}</span>
//                         <span className="text-gray-300">|</span>
//                         <span className="text-gray-600">{report.topic}</span>
//                       </div>

//                       {/* Main Title of publication */}
//                       <a 
//                         href={`https://www.assocham.org/publication-details.php?id=${report.slug}`} 
//                         target="_blank" 
//                         rel="noreferrer" 
//                         className="block mt-1 group"
//                       >
//                         <h4 className="text-lg md:text-xl font-bold text-slate-800 leading-snug group-hover:text-[#DA2128] transition-colors duration-250">
//                           {report.title}
//                         </h4>
//                       </a>
//                     </div>

//                     {/* View report CTA inside card */}
//                     <div className="mt-6 pt-4 border-t border-gray-50 flex items-center justify-between">
//                       <span className="text-xs text-gray-400">Database Reference Code: #PUB-00{report.id}</span>
//                       <a 
//                         href={`https://www.assocham.org/publication-details.php?id=${report.slug}`} 
//                         target="_blank" 
//                         rel="noreferrer"
//                         className="flex items-center gap-1 text-sm font-semibold text-[#F59C00] hover:text-[#DA2128] transition-colors"
//                       >
//                         Read Report <ArrowUpRight className="w-4 h-4" />
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             /* Empty State Container */
//             <div className="bg-white rounded-2xl py-16 px-4 text-center border border-gray-100 shadow-md">
//               <div className="w-16 h-16 bg-[#FAF3F0] rounded-full flex items-center justify-center mx-auto mb-4">
//                 <BookOpen className="text-gray-400 w-8 h-8" />
//               </div>
//               <h3 className="text-lg font-bold text-gray-800">No Research Reports Found</h3>
//               <p className="text-sm text-gray-500 mt-1 max-w-sm mx-auto">
//                 We couldn't find matching publications for "{keyword}". Try adjusting your filters or query word.
//               </p>
//               <button 
//                 onClick={handleResetFilters}
//                 className="mt-4 px-5 py-2 bg-[#F59C00] text-white rounded-xl text-sm font-medium hover:bg-[#da2128] transition-colors shadow-sm"
//               >
//                 Reset All Filters
//               </button>
//             </div>
//           )}
//         </div>

//         {/* 4. ANIMATED MODERN PAGINATION BAR */}
//         {totalPages > 1 && (
//           <div className="mt-12 flex justify-center items-center gap-2">
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className={`p-2.5 rounded-xl border transition-all ${
//                 currentPage === 1 
//                   ? 'border-gray-100 text-gray-300 cursor-not-allowed' 
//                   : 'border-gray-200 text-gray-600 hover:bg-white hover:border-[#DA2128] hover:text-[#DA2128] active:scale-95'
//               }`}
//             >
//               <ChevronLeft className="w-5 h-5" />
//             </button>

//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNo) => (
//               <button
//                 key={pageNo}
//                 onClick={() => handlePageChange(pageNo)}
//                 className={`w-11 h-11 rounded-xl text-sm font-bold transition-all transform active:scale-95 ${
//                   currentPage === pageNo
//                     ? 'bg-[#DA2128] text-white shadow-md shadow-[#DA2128]/30'
//                     : 'bg-white border border-gray-200 text-gray-600 hover:border-[#DA2128] hover:text-[#DA2128]'
//                 }`}
//               >
//                 {pageNo}
//               </button>
//             ))}

//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className={`p-2.5 rounded-xl border transition-all ${
//                 currentPage === totalPages 
//                   ? 'border-gray-100 text-gray-300 cursor-not-allowed' 
//                   : 'border-gray-200 text-gray-600 hover:bg-white hover:border-[#DA2128] hover:text-[#DA2128] active:scale-95'
//               }`}
//             >
//               <ChevronRight className="w-5 h-5" />
//             </button>
//           </div>
//         )}

//         {/* 5. DYNAMIC NEWSLETTER/SUBSCRIBE BLOCK FROM PHP FILE */}
//         <div className="mt-20 bg-gradient-to-r from-[#DA2128] to-[#9E1419] rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden">
//           <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-16 -mt-16 pointer-events-none"></div>
//           <div className="absolute -bottom-8 left-1/4 w-40 h-40 bg-black/10 rounded-full pointer-events-none"></div>
          
//           <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
//             <div className="max-w-md text-center lg:text-left space-y-3">
//               <span className="text-[#F59C00] uppercase font-bold text-xs tracking-widest bg-white/10 px-3.5 py-1 rounded-full">
//                 Keep Updated
//               </span>
//               <h3 className="text-2xl md:text-3xl font-black tracking-tight leading-snug">
//                 Stay current with our latest industry insights
//               </h3>
//               <p className="text-sm text-white/80 font-light">
//                 Sign up to receive immediate notification of new market surveys, whitepapers, and reports.
//               </p>
//             </div>

//             <div className="w-full max-w-md">
//               <form onSubmit={handleSubscriptionSubmit} className="flex flex-col sm:flex-row gap-3">
//                 <div className="relative flex-1">
//                   <input 
//                     type="email" 
//                     required
//                     value={emailInput}
//                     onChange={(e) => setEmailInput(e.target.value)}
//                     placeholder="Enter Your Email Address" 
//                     className="w-full px-5 py-4 bg-white text-gray-800 placeholder-gray-400 rounded-2xl text-sm outline-none focus:ring-4 focus:ring-[#F59C00]/40 border-none transition-shadow"
//                   />
//                   <Mail className="absolute right-4 top-4 text-gray-400 w-5 h-5 pointer-events-none" />
//                 </div>
//                 <button 
//                   type="submit" 
//                   className="px-6 py-4 bg-[#F59C00] hover:bg-amber-500 text-white rounded-2xl text-sm font-bold tracking-wider uppercase transition-all duration-300 transform active:scale-95 flex items-center justify-center gap-2 shadow-lg"
//                 >
//                   Subscribe
//                 </button>
//               </form>
              
//               {subscribed && (
//                 <p className="mt-3 text-xs font-semibold text-[#FAF7F2] animate-bounce bg-white/10 p-2 rounded text-center">
//                   🎉 Thank you for subscribing! Keep an eye on your inbox.
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }





// new new code 




import React, { useState, useEffect, useMemo } from 'react';
import { 
  Search, 
  Calendar, 
  BookOpen, 
  Filter, 
  X, 
  ChevronLeft, 
  ChevronRight, 
  Lock, 
  Globe, 
  SlidersHorizontal,
  Mail,
  ArrowUpRight,
  Loader2,
  AlertCircle
} from 'lucide-react';

// TODO: update this to your actual live endpoint path once uploaded to your server
const API_URL = "https://www.assocham.org/assocham_backend/api/get-publications.php";

export default function ReportSection() {
  // Data fetched from backend
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // State variables matching requirements
  const [keyword, setKeyword] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("All Topics");
  const [selectedType, setSelectedType] = useState("All Types");
  const [selectedYear, setSelectedYear] = useState("All Years");
  const [currentPage, setCurrentPage] = useState(1);
  const [emailInput, setEmailInput] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const ITEMS_PER_PAGE = 6;

  // Fetch publications from PHP backend on mount
  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch(API_URL);
        if (!res.ok) {
          throw new Error(`Server responded with status ${res.status}`);
        }
        const data = await res.json();
        setReports(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to fetch publications:", err);
        setError("Unable to load reports right now. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  // Extract unique filtering values dynamically
  const topicsList = useMemo(() => {
    const list = new Set(reports.map(item => item.topic));
    return ["All Topics", ...Array.from(list)];
  }, [reports]);

  const typesList = useMemo(() => {
    const list = new Set(reports.map(item => item.type));
    return ["All Types", ...Array.from(list)];
  }, [reports]);

  const yearsList = useMemo(() => {
    const list = new Set(reports.map(item => {
      const year = new Date(item.publish_date).getFullYear();
      return year.toString();
    }));
    return ["All Years", ...Array.from(list).sort((a, b) => b - a)];
  }, [reports]);

  // Filter Logic
  const filteredReports = useMemo(() => {
    return reports.filter((report) => {
      const matchesKeyword = report.title.toLowerCase().includes(keyword.toLowerCase()) || 
                             report.topic.toLowerCase().includes(keyword.toLowerCase());
      const matchesTopic = selectedTopic === "All Topics" || report.topic === selectedTopic;
      const matchesType = selectedType === "All Types" || report.type === selectedType;
      const matchesYear = selectedYear === "All Years" || new Date(report.publish_date).getFullYear().toString() === selectedYear;

      return matchesKeyword && matchesTopic && matchesType && matchesYear;
    });
  }, [reports, keyword, selectedTopic, selectedType, selectedYear]);

  // Pagination bounds calculation
  const totalPages = Math.ceil(filteredReports.length / ITEMS_PER_PAGE);
  const displayedReports = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredReports.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredReports, currentPage]);

  const handlePageChange = (pageNo) => {
    if (pageNo >= 1 && pageNo <= totalPages) {
      setCurrentPage(pageNo);
      window.scrollTo({ top: 320, behavior: 'smooth' });
    }
  };

  const handleResetFilters = () => {
    setKeyword("");
    setSelectedTopic("All Topics");
    setSelectedType("All Types");
    setSelectedYear("All Years");
    setCurrentPage(1);
  };

  const handleSubscriptionSubmit = (e) => {
    e.preventDefault();
    if(emailInput.trim() !== "") {
      setSubscribed(true);
      setEmailInput("");
      setTimeout(() => setSubscribed(false), 5000);
    }
  };

  // Helper date formatter function
  const formatDate = (dateStr) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateStr).toLocaleDateString('en-GB', options);
  };

  return (
    <div className="min-h-screen font-sans bg-[#FAF3F0] text-gray-800 selection:bg-[#DA2128]/20 selection:text-[#DA2128]">
      
      {/* 1. HERO BANNER DESIGN */}
      <div className="relative overflow-hidden bg-gradient-to-r from-[#2a2a2a] via-[#1a1a1a] to-[#2a2a2a] py-20 text-white">
        <div className="absolute inset-0 opacity-15 pointer-events-none">
          <div className="absolute -top-1/2 -left-1/4 w-96 h-96 bg-[#DA2128] rounded-full filter blur-[120px]"></div>
          <div className="absolute -bottom-1/2 -right-1/4 w-96 h-96 bg-[#F59C00] rounded-full filter blur-[120px]"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-12">
            <div className="flex-1 text-left space-y-6">
              <span className="inline-flex items-center px-3.5 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider bg-[#DA2128] text-white animate-pulse">
                ASSOCHAM Knowledge Hub
              </span>
              <h1 className="text-4xl md:text-6xl font-black tracking-tight leading-tight">
                Insights <span className="text-[#DA2128]">&</span> Analysis
              </h1>
              <p className="text-lg md:text-xl text-gray-300 max-w-xl font-light">
                Empowering business communities with state-of-the-art reports, research publications, and forward-looking economic analysis.
              </p>
              <div className="h-1.5 w-24 bg-[#F59C00] rounded-full"></div>
            </div>
            
            <div className="flex-1 w-full max-w-md hidden md:block">
              <div className="relative group overflow-hidden rounded-2xl border-4 border-white/10 shadow-2xl transition-transform duration-500 hover:scale-[1.02]">
                <img 
                  src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=800" 
                  alt="Tech Graphics" 
                  className="object-cover w-full h-[280px]" 
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex items-end p-6">
                  <p className="text-sm font-medium text-white/95">Trusted Knowledge Center with 10,000+ active publications.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 -mt-10 relative z-20">
        
        {/* 2. ADVANCED INTERACTIVE FILTER SECTION */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 mb-10 transition-all duration-300 hover:shadow-2xl">
          <div className="flex items-center justify-between border-b border-gray-100 pb-4 mb-6">
            <div className="flex items-center gap-2">
              <SlidersHorizontal className="text-[#DA2128] w-5 h-5" />
              <h3 className="font-bold text-lg text-gray-900 tracking-tight">Refine Intelligence Database</h3>
            </div>
            {(keyword || selectedTopic !== "All Topics" || selectedType !== "All Types" || selectedYear !== "All Years") && (
              <button 
                onClick={handleResetFilters}
                className="flex items-center gap-1.5 text-xs text-red-500 hover:text-red-700 font-medium transition-colors"
              >
                <X className="w-4.5 h-4.5" /> Clear Filters
              </button>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            
            {/* Search Input Box */}
            <div className="relative group">
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Search Key</label>
              <div className="relative">
                <input 
                  type="text" 
                  placeholder="Type titles or keywords..."
                  value={keyword}
                  onChange={(e) => { setKeyword(e.target.value); setCurrentPage(1); }}
                  className="w-full pl-10 pr-4 py-3 bg-[#FAF7F2] border border-gray-200 rounded-xl text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128] focus:border-transparent transition-all duration-300"
                />
                <Search className="absolute left-3.5 top-3.5 text-gray-400 group-focus-within:text-[#DA2128] transition-colors w-4.5 h-4.5" />
              </div>
            </div>

            {/* Topic Filter Select */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Topic Sector</label>
              <div className="relative">
                <select 
                  value={selectedTopic}
                  onChange={(e) => { setSelectedTopic(e.target.value); setCurrentPage(1); }}
                  className="w-full px-4 py-3 bg-[#FAF7F2] border border-gray-200 rounded-xl text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128] focus:border-transparent transition-all duration-300 appearance-none cursor-pointer"
                >
                  {topicsList.map((topic, i) => (
                    <option key={i} value={topic}>{topic}</option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            {/* Report Type Select */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Report Category</label>
              <div className="relative">
                <select 
                  value={selectedType}
                  onChange={(e) => { setSelectedType(e.target.value); setCurrentPage(1); }}
                  className="w-full px-4 py-3 bg-[#FAF7F2] border border-gray-200 rounded-xl text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128] focus:border-transparent transition-all duration-300 appearance-none cursor-pointer"
                >
                  {typesList.map((type, i) => (
                    <option key={i} value={type}>{type}</option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            {/* Date Range Selector */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Publishing Year</label>
              <div className="relative">
                <select 
                  value={selectedYear}
                  onChange={(e) => { setSelectedYear(e.target.value); setCurrentPage(1); }}
                  className="w-full px-4 py-3 bg-[#FAF7F2] border border-gray-200 rounded-xl text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128] focus:border-transparent transition-all duration-300 appearance-none cursor-pointer"
                >
                  {yearsList.map((year, i) => (
                    <option key={i} value={year}>{year}</option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* 3. REPORT LIST VIEWS (As reference image format) */}
        <div className="space-y-6">
          {!loading && !error && (
            <div className="flex justify-between items-center px-2">
              <p className="text-sm font-medium text-gray-500">
                Showing <span className="font-bold text-gray-800">{filteredReports.length}</span> scientific reports
              </p>
            </div>
          )}

          {loading ? (
            /* Loading State */
            <div className="bg-white rounded-2xl py-16 px-4 text-center border border-gray-100 shadow-md">
              <Loader2 className="text-[#DA2128] w-10 h-10 mx-auto mb-4 animate-spin" />
              <h3 className="text-lg font-bold text-gray-800">Fetching Reports</h3>
              <p className="text-sm text-gray-500 mt-1">Pulling the latest publications from the database...</p>
            </div>
          ) : error ? (
            /* Error State */
            <div className="bg-white rounded-2xl py-16 px-4 text-center border border-gray-100 shadow-md">
              <div className="w-16 h-16 bg-[#FAF3F0] rounded-full flex items-center justify-center mx-auto mb-4">
                <AlertCircle className="text-[#DA2128] w-8 h-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-800">Couldn't Load Reports</h3>
              <p className="text-sm text-gray-500 mt-1 max-w-sm mx-auto">{error}</p>
              <button 
                onClick={() => window.location.reload()}
                className="mt-4 px-5 py-2 bg-[#F59C00] text-white rounded-xl text-sm font-medium hover:bg-[#da2128] transition-colors shadow-sm"
              >
                Retry
              </button>
            </div>
          ) : displayedReports.length > 0 ? (
            <div className="space-y-4">
              {displayedReports.map((report, idx) => (
                <div 
                  key={report.id} 
                  className="group relative flex flex-col md:flex-row items-stretch bg-white border border-gray-100/80 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
                  style={{ animationDelay: `${idx * 100}ms` }}
                >
                  {/* Left Side: Thumbnail with dynamic badges */}
                  <div className="relative w-full md:w-56 h-44 md:h-auto min-h-[170px] overflow-hidden flex-shrink-0 bg-gray-200">
                    <img 
                      src={report.image} 
                      alt={report.title} 
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/5 group-hover:bg-black/0 transition-colors"></div>
                    
                    {/* Access Badges */}
                    {report.paid_access === 1 ? (
                      <div className="absolute top-3 left-3 flex items-center gap-1 bg-[#DA2128] text-white text-[10px] uppercase font-bold tracking-widest px-2.5 py-1 rounded shadow-lg backdrop-blur-md">
                        <Lock className="w-3 h-3" /> Members Only
                      </div>
                    ) : (
                      <div className="absolute top-3 left-3 flex items-center gap-1 bg-green-600 text-white text-[10px] uppercase font-bold tracking-widest px-2.5 py-1 rounded shadow-lg backdrop-blur-md">
                        <Globe className="w-3 h-3" /> Free Access
                      </div>
                    )}
                  </div>

                  {/* Right Side: Content Area conforming to user screenshot */}
                  <div className="flex-1 p-6 md:p-8 flex flex-col justify-between">
                    <div>
                      {/* Meta section matching: Date | Category */}
                      <div className="flex flex-wrap items-center gap-2 text-xs font-semibold text-gray-500 mb-3 tracking-wider uppercase">
                        <span className="flex items-center gap-1 text-gray-600 font-medium">
                          <Calendar className="w-3.5 h-3.5 text-[#DA2128]" />
                          {formatDate(report.publish_date)}
                        </span>
                        <span className="text-gray-300">|</span>
                        <span className="text-[#DA2128] font-bold bg-[#DA2128]/5 px-2.5 py-0.5 rounded-full">{report.type}</span>
                        <span className="text-gray-300">|</span>
                        <span className="text-gray-600">{report.topic}</span>
                      </div>

                      {/* Main Title of publication */}
                      <a 
                        href={`https://www.assocham.org/assocham_backend/publication-details.php?id=${report.slug}`} 
                        target="_blank" 
                        rel="noreferrer" 
                        className="block mt-1 group"
                      >
                        <h4 className="text-lg md:text-xl font-bold text-slate-800 leading-snug group-hover:text-[#DA2128] transition-colors duration-250">
                          {report.title}
                        </h4>
                      </a>
                    </div>

                    {/* View report CTA inside card */}
                    <div className="mt-6 pt-4 border-t border-gray-50 flex items-center justify-between">
                      <span className="text-xs text-gray-400">Database Reference Code: #PUB-00{report.id}</span>
                      <a 
                        href={`https://www.assocham.org/assocham_backend/publication-details.php?id=${report.slug}`} 
                        target="_blank" 
                        rel="noreferrer"
                        className="flex items-center gap-1 text-sm font-semibold text-[#F59C00] hover:text-[#DA2128] transition-colors"
                      >
                        Read Report <ArrowUpRight className="w-4 h-4" />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            /* Empty State Container */
            <div className="bg-white rounded-2xl py-16 px-4 text-center border border-gray-100 shadow-md">
              <div className="w-16 h-16 bg-[#FAF3F0] rounded-full flex items-center justify-center mx-auto mb-4">
                <BookOpen className="text-gray-400 w-8 h-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-800">No Research Reports Found</h3>
              <p className="text-sm text-gray-500 mt-1 max-w-sm mx-auto">
                We couldn't find matching publications for "{keyword}". Try adjusting your filters or query word.
              </p>
              <button 
                onClick={handleResetFilters}
                className="mt-4 px-5 py-2 bg-[#F59C00] text-white rounded-xl text-sm font-medium hover:bg-[#da2128] transition-colors shadow-sm"
              >
                Reset All Filters
              </button>
            </div>
          )}
        </div>

        {/* 4. ANIMATED MODERN PAGINATION BAR */}
        {!loading && !error && totalPages > 1 && (
          <div className="mt-12 flex justify-center items-center gap-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`p-2.5 rounded-xl border transition-all ${
                currentPage === 1 
                  ? 'border-gray-100 text-gray-300 cursor-not-allowed' 
                  : 'border-gray-200 text-gray-600 hover:bg-white hover:border-[#DA2128] hover:text-[#DA2128] active:scale-95'
              }`}
            >
              <ChevronLeft className="w-5 h-5" />
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNo) => (
              <button
                key={pageNo}
                onClick={() => handlePageChange(pageNo)}
                className={`w-11 h-11 rounded-xl text-sm font-bold transition-all transform active:scale-95 ${
                  currentPage === pageNo
                    ? 'bg-[#DA2128] text-white shadow-md shadow-[#DA2128]/30'
                    : 'bg-white border border-gray-200 text-gray-600 hover:border-[#DA2128] hover:text-[#DA2128]'
                }`}
              >
                {pageNo}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`p-2.5 rounded-xl border transition-all ${
                currentPage === totalPages 
                  ? 'border-gray-100 text-gray-300 cursor-not-allowed' 
                  : 'border-gray-200 text-gray-600 hover:bg-white hover:border-[#DA2128] hover:text-[#DA2128] active:scale-95'
              }`}
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        )}

        {/* 5. DYNAMIC NEWSLETTER/SUBSCRIBE BLOCK FROM PHP FILE */}
        <div className="mt-20 bg-gradient-to-r from-[#DA2128] to-[#9E1419] rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-16 -mt-16 pointer-events-none"></div>
          <div className="absolute -bottom-8 left-1/4 w-40 h-40 bg-black/10 rounded-full pointer-events-none"></div>
          
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="max-w-md text-center lg:text-left space-y-3">
              <span className="text-[#F59C00] uppercase font-bold text-xs tracking-widest bg-white/10 px-3.5 py-1 rounded-full">
                Keep Updated
              </span>
              <h3 className="text-2xl md:text-3xl font-black tracking-tight leading-snug">
                Stay current with our latest industry insights
              </h3>
              <p className="text-sm text-white/80 font-light">
                Sign up to receive immediate notification of new market surveys, whitepapers, and reports.
              </p>
            </div>

            <div className="w-full max-w-md">
              <form onSubmit={handleSubscriptionSubmit} className="flex flex-col sm:flex-row gap-3">
                <div className="relative flex-1">
                  <input 
                    type="email" 
                    required
                    value={emailInput}
                    onChange={(e) => setEmailInput(e.target.value)}
                    placeholder="Enter Your Email Address" 
                    className="w-full px-5 py-4 bg-white text-gray-800 placeholder-gray-400 rounded-2xl text-sm outline-none focus:ring-4 focus:ring-[#F59C00]/40 border-none transition-shadow"
                  />
                  <Mail className="absolute right-4 top-4 text-gray-400 w-5 h-5 pointer-events-none" />
                </div>
                <button 
                  type="submit" 
                  className="px-6 py-4 bg-[#F59C00] hover:bg-amber-500 text-white rounded-2xl text-sm font-bold tracking-wider uppercase transition-all duration-300 transform active:scale-95 flex items-center justify-center gap-2 shadow-lg"
                >
                  Subscribe
                </button>
              </form>
              
              {subscribed && (
                <p className="mt-3 text-xs font-semibold text-[#FAF7F2] animate-bounce bg-white/10 p-2 rounded text-center">
                  🎉 Thank you for subscribing! Keep an eye on your inbox.
                </p>
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}